export default __webpack_public_path__ + "images/assets/acd01ce709d5310ee236899dafbc16aa.svg";